import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';

import { ScrollToTypography } from '../../components/scroll-to/scroll-to-typography';
import { Spinner } from '../../components/spinner';
import { ApiError } from '../../core/api/api-error';
import {
    ConnectApiErrorResponseDto,
    GetWithdrawableContractsResponseDto
} from '../../core/api/dtos';
import { injectTSDI } from '../../core/common/tsdi';
import { containsErrorWithCode } from '../../core/common/utils';
import { I18n } from '../../core/i18n';
import { ContractWithdrawalStore } from './contract-withdrawal-store';
import { ContractsView } from './contracts/contracts-view';

export const ContractsViewContainer = observer(() => {
    const { translate } = injectTSDI(I18n);
    const { showContractsRequest, addWithdrawContractForm } = injectTSDI(
        ContractWithdrawalStore
    );

    return showContractsRequest.match({
        loading: () => <Spinner />,
        fetched: (contracts: GetWithdrawableContractsResponseDto[]) => {
            contracts.forEach((contract) => addWithdrawContractForm(contract));
            return <ContractsView contracts={contracts} />;
        },
        error: (e: ApiError) => {
            let errorCode = 'public.content.withdraw.contract.error';
            const errors = e.errorMessages as ConnectApiErrorResponseDto[];
            if (e.status === 404) {
                errorCode = 'public.content.common.tenant.not.found';
            } else if (errors) {
                if (containsErrorWithCode('ENTITY_NOT_FOUND', errors)) {
                    errorCode = 'public.content.withdraw.contract.not.found';
                } else if (
                    containsErrorWithCode(
                        'OPERATION_NOT_ALLOWED_FOR_STUDIO',
                        errors
                    )
                ) {
                    errorCode =
                        'public.content.withdraw.contract.no.online.offers';
                } else if (containsErrorWithCode('FEATURE_DISABLED', errors)) {
                    errorCode = 'public.content.withdraw.disabled';
                }
            }
            return (
                <Grid container spacing={10}>
                    <Grid item xs={12}>
                        <ScrollToTypography
                            color="error"
                            data-value={errorCode}
                        >
                            {translate(errorCode)}
                        </ScrollToTypography>
                    </Grid>
                </Grid>
            );
        },
        default: () => <></>
    });
});
